export default __webpack_public_path__ + "static/media/EfficientOrder-100k.012bbac4.png";